import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  uuid: string;
};

const [useDeletePortal, deletePortal] = createAsyncAction(
  "portals/delete",
  async ({ uuid }: Args) => {
    const res = await API.call<{ portal: string }>({
      endpoint: `portals/${uuid}`,
      method: "DELETE",
      data: {
        status: "deleted",
      },
    });
    return { ...res, result: res.result.portal };
  }
);
export default useDeletePortal;
export { deletePortal };
